/** @jsx jsx */
import { gql } from '@apollo/client';
import { Box, Text } from '@bottlebooks/gatsby-design-system';
import { Link } from '@bottlebooks/gatsby-theme-base';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

function hasContent(contact) {
  if (!contact) return false;
  if (contact.name) return true;
  if (contact.title) return true;
  if (contact.office) return true;
  if (contact.mobile) return true;
  if (contact.email) return true;
  if (contact.skypeId) return true;
  if (contact.meetingBookingUrl) return true;
  return false;
}

export default function BrandContact({ contact, ...rest }) {
  const { i18n } = useLingui();
  if (!hasContent(contact)) return null;

  return (
    <Box {...rest}>
      <ContactSegment>{contact.name}</ContactSegment>
      <ContactSegment title={i18n._(t`Title`)}>{contact.title}</ContactSegment>
      <ContactSegment title={i18n._(t`Email`)}>
        {contact.email && (
          <TouchableLink href={`mailto:${contact.email}`}>
            {contact.email}
          </TouchableLink>
        )}
      </ContactSegment>
      <ContactSegment title={i18n._(t`Office phone`)}>
        {contact.office}
      </ContactSegment>
      <ContactSegment title={i18n._(t`Mobile phone`)}>
        {contact.mobile}
      </ContactSegment>
      <ContactSegment title={i18n._(t`Skype ID`)}>
        {contact.skype}
      </ContactSegment>
    </Box>
  );
}
BrandContact.hasContent = hasContent;

function TouchableLink(props) {
  // Returns a link with enough padding to be touched with a finger (at least ~40px).
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <Link sx={{ padding: 1, margin: -1, display: 'inline-block' }} {...props} />
  );
}

function ContactSegment({ children, title = '' }) {
  if (!children) return null;
  return <Text>{children}</Text>;
}

export const fragment = graphql`
  fragment BrandContact on Bottlebooks_BrandContact {
    name
    title
    skypeId
    meetingBookingUrl
    email
    office
    mobile
  }
`;

// Client-only pages need a separate fragment. Unfortunately both must be defined separately.
BrandContact.fragment = gql`
  fragment BrandContact on BrandContact {
    name
    title
    skypeId
    meetingBookingUrl
    email
    office
    mobile
  }
`;
